import { render, staticRenderFns } from "./ColumnIndex2.vue?vue&type=template&id=42c5f2f0&"
import script from "./ColumnIndex2.vue?vue&type=script&lang=js&"
export * from "./ColumnIndex2.vue?vue&type=script&lang=js&"
import style0 from "./ColumnIndex2.vue?vue&type=style&index=0&id=42c5f2f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports